import {
  // brand-invariant groups — shared verbatim with b2c dark
  additional,
  accent as b2cAccent,
  background,
  category,
  core,
  deepGrey,
  deepPurple,
  disabled,
  error,
  ghost,
  green,
  icons,
  orange,
  purple,
  red,
  secondary,
  success,
  tertiary,
  text,
  transparent,
  turquoise,
  warning,
} from './param-dark-palette'
import type {
  Accent,
  Overlay,
  Primary,
  Theme,
} from './themes'

export const primary = {
  maxContrast: '#7566a7',
  highContrast: '#9a80c1',
  upperMidContrast: '#4b3d7a',
  midContrast: '#393056',
  lowerMidContrast: '#393056',
  lowContrast: '#393056',
  reversedContrast: '#f5f6f7',
  // legacy aliases
  mainContrast: '#9a80c1',
  mediumContrast: '#393056',
} as const satisfies Primary

export const overlay = {
  main: '#ffffff',
  accent: '#ffffff',
  tooltip: '#ffffff',
} as const satisfies Overlay

export const accent = {
  maxContrast: b2cAccent.maxContrast,
  highContrast: b2cAccent.highContrast,
  lowerMidContrast: b2cAccent.lowerMidContrast,
  lowContrast: b2cAccent.lowContrast,
  surfaceElement: b2cAccent.surfaceElement,
} as const satisfies Accent

export const palette = {
  additional,
  background,
  disabled,
  error,
  ghost,
  icons,
  overlay,
  primary,
  tertiary,
  secondary,
  accent,
  success,
  text,
  transparent,
  warning,
  deepPurple,
  turquoise,
  green,
  orange,
  red,
  purple,
  core,
  category,
  deepGrey,
} as const satisfies Theme
